<template>
  <button v-if="menuOpen" class="sidebar-backdrop" aria-label="Cerrar menu" @click="closeMenu"></button>
  <aside class="sidebar" :class="{ collapsed: !menuOpen }">
      <div class="sidebar-head">
        <BmotikBrand compact />
        <button class="close-menu" aria-label="Cerrar menu" @click="closeMenu">×</button>
      </div>

      <nav class="menu" aria-label="Navegacion principal">
        <p class="menu-label">Espacio de trabajo</p>
        <router-link to="/app" exact-active-class="router-link-active" @click="closeOnMobile">
          <svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="2"/><rect x="14" y="3" width="7" height="7" rx="2"/><rect x="3" y="14" width="7" height="7" rx="2"/><rect x="14" y="14" width="7" height="7" rx="2"/></svg>
          Resumen
        </router-link>
        <router-link to="/app/eventos" @click="closeOnMobile">
          <svg viewBox="0 0 24 24"><path d="M3 7.5h7l2-2h9v13H3Z"/><path d="M3 9h18"/></svg>
          Eventos
        </router-link>
        <router-link to="/app/grabaciones" @click="closeOnMobile">
          <svg viewBox="0 0 24 24"><rect x="3" y="5" width="14" height="14" rx="3"/><path d="m17 9 4-2v10l-4-2Z"/></svg>
          Grabaciones
        </router-link>
        <router-link to="/app/enlaces" @click="closeOnMobile">
          <svg viewBox="0 0 24 24"><path d="M10 13a5 5 0 0 0 7.1.1l2-2a5 5 0 0 0-7.1-7.1l-1.1 1.1"/><path d="M14 11a5 5 0 0 0-7.1-.1l-2 2A5 5 0 0 0 12 20l1.1-1.1"/></svg>
          Enlaces temporales
        </router-link>

        <p class="menu-label">Cuenta</p>
        <router-link to="/cuenta" @click="closeOnMobile">
          <svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>
          Mi cuenta
        </router-link>
      </nav>

      <div class="sidebar-foot">
        <div class="sync-note">
          <span></span>
          <div><strong>Servicio disponible</strong><small>Listo para sincronizar MP4</small></div>
        </div>
        <button class="logout" @click="logoutAndClose">Cerrar sesion</button>
      </div>
  </aside>
</template>

<script>
import { mapActions } from 'vuex';
import BmotikBrand from '@/components/brand/BmotikBrand.vue';

export default {
  components: { BmotikBrand },
  props: { menuOpen: { type: Boolean, required: true } },
  methods: {
    ...mapActions(['logout']),
    closeMenu() { this.$emit('close-menu'); },
    closeOnMobile() { if (window.innerWidth < 992) this.closeMenu(); },
    async logoutAndClose() {
      await this.logout();
      this.closeMenu();
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar { position: fixed; inset: 4.7rem auto 0 0; z-index: 850; width: 17rem; padding: 1rem; display: flex; flex-direction: column; border-right: 1px solid var(--bm-border); background: rgba(255,255,255,.96); box-shadow: 8px 0 30px rgba(29,29,117,.035); backdrop-filter: blur(18px); transition: transform .2s ease; }
.sidebar.collapsed { transform: translateX(-100%); }
.sidebar-head { min-height: 58px; padding: .5rem .55rem .85rem; display: flex; align-items: center; justify-content: space-between; gap: .6rem; border-bottom: 1px solid var(--bm-border); }
.close-menu { width: 34px; height: 34px; display: none; place-items: center; border: 1px solid var(--bm-border); border-radius: 9px; color: var(--bm-muted); background: #fff; font-size: 1.25rem; cursor: pointer; }
.menu { min-height: 0; padding: .85rem 0 1rem; display: flex; flex-direction: column; gap: .25rem; overflow: auto; }
.menu-label { margin: .9rem .8rem .28rem; color: var(--bm-muted); font-size: .62rem; font-weight: 850; letter-spacing: .13em; text-transform: uppercase; }
.menu a { min-height: 43px; padding: .68rem .78rem; display: flex; align-items: center; gap: .72rem; border-radius: 10px; color: #555966; font-size: .82rem; font-weight: 700; text-decoration: none; transition: color .15s ease, background .15s ease; }
.menu svg { width: 18px; height: 18px; flex: 0 0 auto; fill: none; stroke: currentColor; stroke-width: 1.7; stroke-linecap: round; stroke-linejoin: round; }
.menu a:hover { color: var(--bm-indigo); background: var(--bm-tint); }
.menu a.router-link-active { color: #fff; background: var(--bm-blue); box-shadow: 0 8px 20px rgba(63,91,234,.21); }
.sidebar-foot { margin-top: auto; padding-top: .85rem; border-top: 1px solid var(--bm-border); }
.sync-note { padding: .7rem; display: flex; align-items: center; gap: .65rem; border-radius: 10px; background: #f4fbf7; }
.sync-note > span { width: 9px; height: 9px; flex: 0 0 auto; border-radius: 50%; background: #20a565; box-shadow: 0 0 0 4px rgba(32,165,101,.12); }
.sync-note div { min-width: 0; display: flex; flex-direction: column; gap: .1rem; }
.sync-note strong { color: #156c43; font-size: .7rem; }
.sync-note small { overflow: hidden; color: #5e7a6d; font-size: .6rem; text-overflow: ellipsis; white-space: nowrap; }
.logout { width: 100%; min-height: 40px; margin-top: .65rem; border: 1px solid #efc9cf; border-radius: 10px; color: var(--bm-red); background: #fff6f7; font-size: .77rem; font-weight: 750; cursor: pointer; }
.sidebar-backdrop { display: none; }
@media (max-width: 991px) {
  .sidebar { transform: translateX(-100%); box-shadow: 16px 0 50px rgba(20,21,55,.18); }
  .sidebar:not(.collapsed) { transform: translateX(0); }
  .close-menu { display: grid; }
  .sidebar-backdrop { position: fixed; inset: 4.7rem 0 0; z-index: 840; display: block; border: 0; background: rgba(18,18,48,.34); backdrop-filter: blur(4px); }
}
</style>
